/// <amd-module name="VSSUI/Components/ClipboardButton/ClipboardButton" />
import * as React from "react";
import { ObservableValue } from "VSS/Core/Observable";
import { Button } from "VSSUI/Button";
import { Observer } from "VSSUI/Observer";
import * as Resources from "VSSUI/Resources.Clipboard";
import { css } from "VSSUI/Util";
import { copyToClipboard } from "../../Utils/ClipboardUtils";
import { IClipboardButtonProps } from "./ClipboardButton.Props";

export class ClipboardButton extends React.Component<IClipboardButtonProps> {
    private copied = new ObservableValue<boolean>(false);

    public render() {
        const { ariaLabel, onBlur, onFocus, showCopiedTooltip, subtle, tooltipProps } = this.props;

        const copiedTooltipText = typeof showCopiedTooltip === "string" ? showCopiedTooltip : Resources.CopiedToClipboard;

        return (
            <div className={css("bolt-clipboard-button", this.props.className)}>
                <Observer copied={this.copied}>
                    {(props: { copied: boolean }) => {
                        return (
                            <Button
                                ariaLabel={ariaLabel || Resources.CopyToClipboard}
                                iconProps={{ iconName: "Copy" }}
                                onBlur={onBlur}
                                onClick={this.onClick}
                                onFocus={onFocus}
                                subtle={subtle}
                                tooltipProps={showCopiedTooltip && props.copied ? { ...tooltipProps, text: copiedTooltipText } : tooltipProps}
                                onMouseLeave={this.onMouseLeave}
                            />
                        );
                    }}
                </Observer>
            </div>
        );
    }

    private onClick = (event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>) => {
        const { getContent, onCopy } = this.props;

        if (!this.copied.value) {
            this.copied.value = true;
        }

        const content = getContent();

        copyToClipboard(content, onCopy);

        event.preventDefault();
        event.stopPropagation();
    };

    private onMouseLeave = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        if (this.copied.value) {
            this.copied.value = false;
        }
        this.props.onMouseLeave && this.props.onMouseLeave(event);
    };
}
